module.exports = __webpack_public_path__ + "media/images/portugal_center/Dornes-8ca5b3f13b3d37326843c7634e73fe6b.jpg";